"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
class WCAGAnchor extends fmko_ts_common_1.Widget {
    constructor({ rel, href, target, text }) {
        super();
        this.element = document.createElement("a");
        this.element.classList.add("wcag-anchor");
        this.element.textContent = text;
        this.element.href = href;
        this.element.target = target || "_blank";
        this.element.rel = rel || "noopener noreferrer";
    }
}
exports.default = WCAGAnchor;
//# sourceMappingURL=WCAGAnchor.js.map